import { ObservationSummary } from '../../objects/observationSummary';
import { Endpoint, RequestMethod } from '../../public_api';
import { ApiResponse } from '../apiResponse.interface';
import { MockObservationMaker } from './mockObservationMaker';

export class GetObservationsForExport extends Endpoint<
  Array<ObservationSummary>,
  GetObservationsForExportParams,
  ObservationSummary
> {
  protected callLive(params: GetObservationsForExportParams): Promise<Array<ObservationSummary>> {
    const callResponsePromise = this.apiCaller.doCall(
      'observations_export',
      RequestMethod.GET,
      this.removeNullsFromObject(params.filterParametersObject) as Record<string, string>,
    );

    return this.buildObjectsFromResponse(ObservationSummary, callResponsePromise);
  }

  /* eslint-disable @typescript-eslint/no-unused-vars */
  protected callMock(params: GetObservationsForExportParams): Promise<Array<ObservationSummary>> {
    const srcObjects = new Array<object>();
    for (let i = 0; i < 100; i++) {
      srcObjects.push(MockObservationMaker.doSummaryReplacements(i));
    }

    return this.buildObjectsFromResponse(
      ObservationSummary,
      ApiResponse.createMockResponseObject(srcObjects),
    );
  }
}

export interface GetObservationsForExportParams {
  filterParametersObject: Record<string, string>;
}
